import { parse, Kind, isSchema, isDefinitionNode, } from 'graphql';
import { defaultStringComparator, isSourceTypes, isStringTypes } from './utils';
import { mergeGraphQLNodes, schemaDefSymbol } from './merge-nodes';
import { resetComments, printWithComments } from './comments';
import { getDocumentNodeFromSchema } from '@graphql-tools/utils';
import { operationTypeDefinitionNodeTypeRootTypeMap } from './schema-def';
export function mergeTypeDefs(types, config) {
    resetComments();
    const doc = {
        kind: Kind.DOCUMENT,
        definitions: mergeGraphQLTypes(types, {
            useSchemaDefinition: true,
            forceSchemaDefinition: false,
            throwOnConflict: false,
            commentDescriptions: false,
            ...config,
        }),
    };
    let result;
    if (config && config.commentDescriptions) {
        result = printWithComments(doc);
    }
    else {
        result = doc;
    }
    resetComments();
    return result;
}
function visitTypeSources(types, allNodes) {
    for (const type of types) {
        if (type) {
            if (Array.isArray(type)) {
                visitTypeSources(types, allNodes);
            }
            else if (isSchema(type)) {
                const documentNode = getDocumentNodeFromSchema(type);
                visitTypeSources(documentNode.definitions, allNodes);
            }
            else if (isStringTypes(type) || isSourceTypes(type)) {
                const documentNode = parse(type);
                visitTypeSources(documentNode.definitions, allNodes);
            }
            else if (isDefinitionNode(type)) {
                allNodes.push(type);
            }
            else {
                visitTypeSources(type.definitions, allNodes);
            }
        }
    }
}
export function mergeGraphQLTypes(types, config) {
    var _a, _b;
    resetComments();
    const allNodes = [];
    visitTypeSources(types, allNodes);
    const mergedNodes = mergeGraphQLNodes(allNodes, config);
    // XXX: right now we don't handle multiple schema definitions
    let schemaDef = mergedNodes[schemaDefSymbol] || {
        kind: Kind.SCHEMA_DEFINITION,
        operationTypes: [],
    };
    if (config === null || config === void 0 ? void 0 : config.useSchemaDefinition) {
        const operationTypes = schemaDef.operationTypes;
        for (const opTypeDefNodeType in operationTypeDefinitionNodeTypeRootTypeMap) {
            const opTypeDefNode = operationTypes.find(operationType => operationType.operation === opTypeDefNodeType);
            if (!opTypeDefNode) {
                const existingPossibleRootType = mergedNodes[operationTypeDefinitionNodeTypeRootTypeMap[opTypeDefNodeType]];
                if (existingPossibleRootType) {
                    operationTypes.push({
                        kind: Kind.OPERATION_TYPE_DEFINITION,
                        type: {
                            kind: Kind.NAMED_TYPE,
                            name: existingPossibleRootType.name,
                        },
                        operation: opTypeDefNodeType,
                    });
                }
            }
        }
    }
    if ((config === null || config === void 0 ? void 0 : config.forceSchemaDefinition) && !((_a = schemaDef === null || schemaDef === void 0 ? void 0 : schemaDef.operationTypes) === null || _a === void 0 ? void 0 : _a.length)) {
        schemaDef = {
            kind: Kind.SCHEMA_DEFINITION,
            operationTypes: [
                {
                    kind: Kind.OPERATION_TYPE_DEFINITION,
                    operation: 'query',
                    type: {
                        kind: Kind.NAMED_TYPE,
                        name: {
                            kind: Kind.NAME,
                            value: 'Query',
                        },
                    },
                },
            ],
        };
    }
    const mergedNodeDefinitions = Object.values(mergedNodes);
    if ((_b = schemaDef.operationTypes) === null || _b === void 0 ? void 0 : _b.length) {
        mergedNodeDefinitions.push(schemaDef);
    }
    if (config === null || config === void 0 ? void 0 : config.sort) {
        const sortFn = typeof config.sort === 'function' ? config.sort : defaultStringComparator;
        mergedNodeDefinitions.sort((a, b) => { var _a, _b; return sortFn((_a = a.name) === null || _a === void 0 ? void 0 : _a.value, (_b = b.name) === null || _b === void 0 ? void 0 : _b.value); });
    }
    return mergedNodeDefinitions;
}
//# sourceMappingURL=merge-typedefs.js.map